import axios from 'axios'
import { ElMessage } from 'element-plus'
import { API_BASE } from '@/config/api'

const service = axios.create({
  baseURL: API_BASE,
  timeout: 15000
})

service.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token')
    config.headers = config.headers || {}
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }
    // Important: when uploading files with FormData,
    // do NOT force application/json; let axios set multipart/form-data + boundary.
    const isFormData = typeof FormData !== 'undefined' && config.data instanceof FormData
    if (!isFormData) {
      config.headers['Content-Type'] = 'application/json'
    } else {
      delete config.headers['Content-Type']
    }
    return config
  },
  error => {
    console.error('Request error:', error)
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  response => {
    const res = response.data
    // 某些接口业务码不是 200（但 HTTP 200 成功），允许按调用方配置跳过业务码拦截
    if (response.config && response.config.skipBizCodeCheck) {
      return res
    }
    if (res.code !== 200) {
      ElMessage({
        message: res.message || 'Error',
        type: 'error',
        duration: 5 * 1000
      })
      return Promise.reject(new Error(res.message || 'Error'))
    } else {
      return res
    }
  },
  error => {
    console.error('Response error:', error)
    ElMessage({
      message: error.message || '请求失败',
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service
